export const ZIP_CODE_CONSTANTS = {
  USA: {
    MAX_LENGTH: 5,
    LABEL: 'Zip code',
    PLACEHOLDER: 'e.g. 90001',
    ERROR_MESSAGE: 'Please enter a valid US ZIP code (e.g., 20500)',
  },
  CANADA: {
    MAX_LENGTH: 6,
    LABEL: 'Postal code',
    PLACEHOLDER: 'e.g. A1A 1A1',
    ERROR_MESSAGE: 'Please enter a valid Canadian postal code (e.g., K1A 0A9)',
  },
  OTHER: {
    LABEL: 'Postal code',
    PLACEHOLDER: 'Enter postal code',
    ERROR_MESSAGE: 'Please enter a valid code',
  },
} as const

export const getZipCodeErrorMessageByCountry = (countryId: string): string => {
  if (countryId === 'US') return ZIP_CODE_CONSTANTS.USA.ERROR_MESSAGE
  if (countryId === 'CA') return ZIP_CODE_CONSTANTS.CANADA.ERROR_MESSAGE
  return ZIP_CODE_CONSTANTS.OTHER.ERROR_MESSAGE
}

export const STATE_LABELS = {
  USA: 'State',
  CANADA: 'Province',
  OTHER: 'Region',
} as const

export const CITY_PLACEHOLDERS = {
  USA: 'e.g. Los Angeles',
  CANADA: 'e.g. Toronto',
  OTHER: 'Enter city',
} as const

export type ICheckZipCodeLengthParams = {
  zipLength: number | undefined
  isUsaLocation: boolean
  isCanadaLocation: boolean
}

export const getZipCodeValidationError = ({
  zipLength,
  isUsaLocation,
  isCanadaLocation,
}: ICheckZipCodeLengthParams): string | null => {
  if (isUsaLocation) {
    return zipLength !== ZIP_CODE_CONSTANTS.USA.MAX_LENGTH
      ? ZIP_CODE_CONSTANTS.USA.ERROR_MESSAGE
      : null
  }
  if (isCanadaLocation) {
    return zipLength !== ZIP_CODE_CONSTANTS.CANADA.MAX_LENGTH
      ? ZIP_CODE_CONSTANTS.CANADA.ERROR_MESSAGE
      : null
  }
  return zipLength === 0 ? ZIP_CODE_CONSTANTS.OTHER.ERROR_MESSAGE : null
}
